import { createSelector } from '@reduxjs/toolkit';
import { selectDealType } from 'shared/selectors/jsonQuery';
import {
  selectHasDistricts,
  selectHasHighways,
  selectHasRegionalDistricts,
  selectHasUnderground,
} from 'shared/selectors/location';
import { FDealType } from '../../../../packages/JsonQuery';

export enum EGeoType {
  Underground = 1,
  RegionalDistricts = 2,
  District = 3,
  Highway = 4,
}

export const selectGeoTypeFilter = createSelector(
  [selectHasUnderground, selectHasRegionalDistricts, selectHasDistricts, selectHasHighways, selectDealType],
  (hasUnderground, hasRegionalDistricts, hasDistricts, hasHighways, dealType) => {
    const geoTypeItems = [];

    if (hasUnderground) {
      geoTypeItems.push({ text: 'Метро', id: EGeoType.Underground });
    }

    if (hasRegionalDistricts) {
      geoTypeItems.push({ text: 'Район', id: EGeoType.RegionalDistricts });
    }

    if ((dealType !== FDealType.RentDaily || !hasUnderground) && hasDistricts && !hasRegionalDistricts) {
      geoTypeItems.push({ text: 'Район', id: EGeoType.District });
    }

    if (
      hasHighways &&
      (dealType !== FDealType.RentDaily || hasUnderground) &&
      (!hasDistricts || hasRegionalDistricts)
    ) {
      geoTypeItems.push({ text: 'Шоссе', id: EGeoType.Highway });
    }

    const geoTypeLabel = geoTypeItems
      .map(item => item.text)
      .filter(Boolean)
      .join(', ');

    return { label: geoTypeLabel || '', tabItems: geoTypeItems };
  },
);
